<template>
    <div class="monthly-agent-stats">
         <!-- Агрегированные данные за всё время -->
         <div class="row mb-4">
             <div class="col-12">
                 <h5 class="ml-4">Итого за всё время</h5>
                 <div class="row justify-content-between">
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-green">{{ allTimeTotals.new_registrations }}</div>
                                 <div class="stat-label">Всего регистрации</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-green">{{ allTimeTotals.signed_offers }}</div>
                                 <div class="stat-label">Подписали оферту</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value">{{ allTimeTotals.terminations }}</div>
                                 <div class="stat-label">Расторжения</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value">{{ allTimeTotals.deleted_without_offer }}</div>
                                 <div class="stat-label">Удалились без оферты</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value">{{ allTimeTotals.watched_lessons }}</div>
                                 <div class="stat-label">Досмотрели уроки</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-blue">{{ allTimeTotals.orders_created }}</div>
                                 <div class="stat-label">Оформлено заявок</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-green">{{ allTimeTotals.orders_supply }}</div>
                                 <div class="stat-label">Перешли в поставку</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-orange">{{ allTimeTotals.phone_interviews }}</div>
                                 <div class="stat-label">Телефонные интервью</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-warning">{{ allTimeTotals.interviews_scheduled }}</div>
                                 <div class="stat-label">Назначено собеседований</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-blue">{{ allTimeTotals.interviews_conducted }}</div>
                                 <div class="stat-label">Проведено собеседований</div>
                             </div>
                         </b-card>
                     </div>
                 </div>
             </div>
         </div>

        <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0 ml-4">Статистика агентов за {{ currentMonthName }} по дням</h5>
            <div class="d-flex align-items-center">
                <b-form-select
                    v-model="selectedMonth"
                    :options="monthOptions"
                    @change="loadMonthlyData"
                    class="mr-3"
                    size="sm"
                    style="width: 200px;"
                />
                <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="refreshData"
                    :disabled="loading"
                    class="mr-2"
                >
                    <i class="fas fa-sync-alt" :class="{ 'fa-spin': loading }"></i>
                </b-button>
                <b-button
                    variant="outline-success"
                    size="sm"
                    @click="toggleEditMode"
                    :disabled="loading"
                >
                    <i class="fas fa-edit"></i> {{ isEditing ? 'Завершить' : '' }}
                </b-button>
            </div>
        </div>

        <!-- Таблица по дням -->
        <div class="table-responsive" style="overflow-x: auto;">
            <table class="table table-bordered table-sm">
                <thead class="thead-light">
                    <tr>
                        <th class="sticky-column" style="width: 200px; min-width: 200px; height: 40px;">День</th>
                        <th 
                            v-for="day in monthlyData" 
                            :key="day.date"
                            class="text-center"
                            style="width: 80px; min-width: 80px;"
                        >
                            {{ day.day }}
                            <i 
                                class="fas fa-copy copy-icon" 
                                @click="copyDayReport(day)"
                                title="Копировать отчет за день"
                            ></i>
                        </th>
                        <th class="text-center font-weight-bold sticky-right" style="width: 100px; min-width: 100px; background-color: #e9ecef;">
                            Итого
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="sticky-column font-weight-bold">Новые регистрации</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`new_registrations_${day.date}`"
                            class="text-center"
                        >
                            {{ day.new_registrations }}
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.new_registrations }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Подписали оферту</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`signed_offers_${day.date}`"
                            class="text-center"
                        >
                            {{ day.signed_offers }}
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.signed_offers }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Расторжения</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`terminations_${day.date}`"
                            class="text-center"
                        >
                            {{ day.terminations }}
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.terminations }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Удалились без оферты</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`deleted_without_offer_${day.date}`"
                            class="text-center"
                        >
                            {{ day.deleted_without_offer }}
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.deleted_without_offer }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Досмотрели уроки</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`watched_lessons_${day.date}`"
                            class="text-center"
                        >
                            {{ day.watched_lessons }}
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.watched_lessons }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Оформлено заявок</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`orders_created_${day.date}`"
                            class="text-center"
                        >
                            {{ day.orders_created }}
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.orders_created }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Перешли в поставку</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`orders_supply_${day.date}`"
                            class="text-center"
                        >
                            {{ day.orders_supply }}
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.orders_supply }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Проведено телефонных интервью</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`phone_interviews_${day.date}`"
                            class="text-center"
                        >
                            <b-form-input
                                v-if="isEditing"
                                v-model="day.phone_interviews"
                                type="number"
                                min="0"
                                size="sm"
                                class="text-center"
                                @blur="saveDayData(day, 'phone_interviews')"
                                @keydown.enter="saveDayData(day, 'phone_interviews')"
                                @input="updateMonthlyTotals()"
                            />
                            <span v-else>{{ day.phone_interviews || 0 }}</span>
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.phone_interviews }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Назначено собеседований</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`interviews_scheduled_${day.date}`"
                            class="text-center"
                        >
                            <b-form-input
                                v-if="isEditing"
                                v-model="day.interviews_scheduled"
                                type="number"
                                min="0"
                                size="sm"
                                class="text-center"
                                @blur="saveDayData(day, 'interviews_scheduled')"
                                @keydown.enter="saveDayData(day, 'interviews_scheduled')"
                                @input="updateMonthlyTotals()"
                            />
                            <span v-else>{{ day.interviews_scheduled || 0 }}</span>
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.interviews_scheduled }}
                        </td>
                    </tr>
                    <tr>
                        <td class="sticky-column font-weight-bold">Проведено собеседований</td>
                        <td 
                            v-for="day in monthlyData" 
                            :key="`interviews_conducted_${day.date}`"
                            class="text-center"
                        >
                            <b-form-input
                                v-if="isEditing"
                                v-model="day.interviews_conducted"
                                type="number"
                                min="0"
                                size="sm"
                                class="text-center"
                                @blur="saveDayData(day, 'interviews_conducted')"
                                @keydown.enter="saveDayData(day, 'interviews_conducted')"
                                @input="updateMonthlyTotals()"
                            />
                            <span v-else>{{ day.interviews_conducted || 0 }}</span>
                        </td>
                        <td class="text-center font-weight-bold sticky-right">
                            {{ monthlyTotals.interviews_conducted }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

         <!-- Агрегированные данные за месяц -->
         <div class="row mb-4 mt-5">
             <div class="col-12">
                 <h5 class="ml-4">Итого за {{ currentMonthName }}</h5>
                 <div class="row justify-content-between">
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-green">{{ monthlyTotals.new_registrations }}</div>
                                 <div class="stat-label">Новые регистрации</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-green">{{ monthlyTotals.signed_offers }}</div>
                                 <div class="stat-label">Подписали оферту</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value">{{ monthlyTotals.terminations }}</div>
                                 <div class="stat-label">Расторжения</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value">{{ monthlyTotals.deleted_without_offer }}</div>
                                 <div class="stat-label">Удалились без оферты</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value">{{ monthlyTotals.watched_lessons }}</div>
                                 <div class="stat-label">Досмотрели уроки</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-blue">{{ monthlyTotals.orders_created }}</div>
                                 <div class="stat-label">Оформлено заявок</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-green">{{ monthlyTotals.orders_supply }}</div>
                                 <div class="stat-label">Перешли в поставку</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-orange">{{ monthlyTotals.phone_interviews }}</div>
                                 <div class="stat-label">Телефонные интервью</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-warning">{{ monthlyTotals.interviews_scheduled }}</div>
                                 <div class="stat-label">Назначено собеседований</div>
                             </div>
                         </b-card>
                     </div>
                     <div class="col mb-4">
                         <b-card class="stat-card h-100">
                             <div class="d-flex flex-column align-items-center justify-content-center text-center">
                                 <div class="stat-value text-brand-blue">{{ monthlyTotals.interviews_conducted }}</div>
                                 <div class="stat-label">Проведено собеседований</div>
                             </div>
                         </b-card>
                     </div>
                 </div>
             </div>
         </div>

    </div>
</template>

<script>
import { 
    API_AGENT_COMPANY,
    API_AGENT_DAILY_STATISTICS_MONTHLY_STATS,
    API_AGENT_DAILY_STATISTICS_UPDATE,
    API_AGENT_DAILY_STATISTICS_ALL_TIME
} from '@/constants'

export default {
    name: 'DailyAgentStats',
    data() {
        return {
            loading: false,
            selectedMonth: null,
            monthlyData: [],
            monthlyTotals: {
                new_registrations: 0,
                signed_offers: 0,
                terminations: 0,
                deleted_without_offer: 0,
                watched_lessons: 0,
                orders_created: 0,
                orders_supply: 0,
                phone_interviews: 0,
                interviews_scheduled: 0,
                interviews_conducted: 0,
                total: 0
            },
            allTimeTotals: {
                new_registrations: 0,
                signed_offers: 0,
                terminations: 0,
                deleted_without_offer: 0,
                watched_lessons: 0,
                orders_created: 0,
                orders_supply: 0,
                phone_interviews: 0,
                interviews_scheduled: 0,
                interviews_conducted: 0,
                total: 0
            },
            isEditing: false,
            monthOptions: []
        }
    },
    computed: {
        currentMonthName() {
            if (!this.selectedMonth) return ''
            const [year, month] = this.selectedMonth.split('-')
            const monthNames = [
                'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
                'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
            ]
            return `${monthNames[parseInt(month) - 1]} ${year}`
        }
    },
    mounted() {
        this.generateMonthOptions()
        this.selectedMonth = this.getCurrentMonth()
        this.loadMonthlyData()
        this.loadAllTimeData()
    },
    methods: {
        generateMonthOptions() {
            const options = []
            const currentDate = new Date()
            
            // Генерируем последние 12 месяцев
            for (let i = 0; i < 12; i++) {
                const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1)
                const year = date.getFullYear()
                const month = String(date.getMonth() + 1).padStart(2, '0')
                const value = `${year}-${month}`
                const label = `${this.getMonthName(date.getMonth())} ${year}`
                options.push({ value, text: label })
            }
            
            this.monthOptions = options
        },
        
        getMonthName(monthIndex) {
            const monthNames = [
                'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
                'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
            ]
            return monthNames[monthIndex]
        },
        
        getCurrentMonth() {
            const now = new Date()
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            return `${year}-${month}`
        },
        
        async loadMonthlyData() {
            if (!this.selectedMonth) return
            
            try {
                this.loading = true
                
                const [year, month] = this.selectedMonth.split('-')
                
                // Загружаем основные данные
                const { data } = await axios.get(`${API_AGENT_COMPANY}/monthly-stats`, {
                    params: {
                        year: parseInt(year),
                        month: parseInt(month)
                    }
                })
                
                this.monthlyData = data.daily_stats || []
                this.monthlyTotals = data.monthly_totals || this.monthlyTotals
                
                
                // Загружаем дневные статистики
                const statsResponse = await axios.get(API_AGENT_DAILY_STATISTICS_MONTHLY_STATS, {
                    params: {
                        year: parseInt(year),
                        month: parseInt(month)
                    }
                })
                
                if (statsResponse.data.success) {
                    // Обновляем дневные данные
                    this.monthlyData.forEach((day, index) => {
                        // Нормализуем даты для сравнения
                        const dayDate = day.date.split('T')[0] // Берем только дату без времени
                        const dayStats = statsResponse.data.data.find(stat => {
                            const statDate = stat.date.split('T')[0] // Берем только дату без времени
                            return statDate === dayDate
                        })
                        
                        if (dayStats) {
                            // Используем Vue.set для правильного обновления реактивности и приводим к числам
                            this.$set(this.monthlyData[index], 'phone_interviews', parseInt(dayStats.phone_interviews || 0))
                            this.$set(this.monthlyData[index], 'interviews_scheduled', parseInt(dayStats.interviews_scheduled || 0))
                            this.$set(this.monthlyData[index], 'interviews_conducted', parseInt(dayStats.interviews_conducted || 0))
                        } else {
                            this.$set(this.monthlyData[index], 'phone_interviews', 0)
                            this.$set(this.monthlyData[index], 'interviews_scheduled', 0)
                            this.$set(this.monthlyData[index], 'interviews_conducted', 0)
                        }
                    })
                    
                    // Обновляем месячные итоги
                    this.updateMonthlyTotals()
                }
                
            } catch (error) {
                console.error('Ошибка загрузки месячных данных:', error)
                this.$bvToast.toast('Ошибка загрузки данных', {
                    variant: 'danger',
                    title: 'Ошибка'
                })
            } finally {
                this.loading = false
            }
        },
        
        async loadAllTimeData() {
            try {
                // Загружаем основные данные
                const { data } = await axios.get(`${API_AGENT_COMPANY}/all-time-stats`)
                this.allTimeTotals = data || this.allTimeTotals
                
                // Загружаем дополнительные статистики
                const statsResponse = await axios.get(API_AGENT_DAILY_STATISTICS_ALL_TIME)
                
                if (statsResponse.data.success) {
                    this.allTimeTotals.phone_interviews = statsResponse.data.data.phone_interviews || 0
                    this.allTimeTotals.interviews_scheduled = statsResponse.data.data.interviews_scheduled || 0
                    this.allTimeTotals.interviews_conducted = statsResponse.data.data.interviews_conducted || 0
                }
            } catch (error) {
                console.error('Ошибка загрузки общих данных:', error)
            }
        },
        
        async refreshData() {
            await Promise.all([
                this.loadMonthlyData(),
                this.loadAllTimeData()
            ])
        },

        toggleEditMode() {
            this.isEditing = !this.isEditing
            
            if (!this.isEditing) {
                // При выходе из режима редактирования обновляем данные
                this.refreshData()
            }
        },


        async saveDayData(day, field) {
            try {
                const value = parseInt(day[field]) || 0
                
                // Просто берем дату в формате YYYY-MM-DD
                const simpleDate = day.date.split('T')[0]
                
                const response = await axios.post(API_AGENT_DAILY_STATISTICS_UPDATE, {
                    date: simpleDate,
                    phone_interviews: parseInt(day.phone_interviews || 0),
                    interviews_scheduled: parseInt(day.interviews_scheduled || 0),
                    interviews_conducted: parseInt(day.interviews_conducted || 0)
                })

                if (response.data.success) {
                    // Месячные итоги уже обновлены через @input
                } else {
                    throw new Error(response.data.message || 'Ошибка при сохранении')
                }
            } catch (error) {
                console.error('Ошибка сохранения данных дня:', error)
                this.$bvToast.toast('Ошибка при сохранении данных', {
                    variant: 'danger',
                    title: 'Ошибка'
                })
            }
        },

        updateMonthlyTotals() {
            // Пересчитываем месячные итоги на основе дневных данных
            this.monthlyTotals.phone_interviews = this.monthlyData.reduce((sum, day) => sum + parseInt(day.phone_interviews || 0), 0)
            this.monthlyTotals.interviews_scheduled = this.monthlyData.reduce((sum, day) => sum + parseInt(day.interviews_scheduled || 0), 0)
            this.monthlyTotals.interviews_conducted = this.monthlyData.reduce((sum, day) => sum + parseInt(day.interviews_conducted || 0), 0)
        },

        copyDayReport(day) {
            const date = new Date(day.date).toLocaleDateString('ru-RU')
            
            const report = `Отчет за ${date}
Новые регистрации: ${day.new_registrations || 0}
Подписали оферту: ${day.signed_offers || 0}
Расторжения: ${day.terminations || 0}
Удалились без оферты: ${day.deleted_without_offer || 0}
Досмотрели уроки: ${day.watched_lessons || 0}
Оформлено заявок: ${day.orders_created || 0}
Перешли в поставку: ${day.orders_supply || 0}
Проведено телефонных интервью: ${day.phone_interviews || 0}
Назначено собеседований: ${day.interviews_scheduled || 0}
Проведено собеседований: ${day.interviews_conducted || 0}`
            
            // Копируем в буфер обмена
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(report).then(() => {
                    this.$bvToast.toast('Отчет скопирован в буфер обмена', {
                        variant: 'success',
                        title: 'Данные скопированы',
                        autoHideDelay: 2000
                    })
                }).catch(() => {
                    this.fallbackCopy(report)
                })
            } else {
                this.fallbackCopy(report)
            }
        },

        fallbackCopy(text) {
            // Fallback для старых браузеров
            const textArea = document.createElement('textarea')
            textArea.value = text
            textArea.style.position = 'fixed'
            textArea.style.left = '-999999px'
            textArea.style.top = '-999999px'
            document.body.appendChild(textArea)
            textArea.focus()
            textArea.select()
            
            try {
                const successful = document.execCommand('copy')
                if (successful) {
                    this.$bvToast.toast('Отчет скопирован в буфер обмена', {
                        variant: 'success',
                        title: 'Данные скопированы',
                        autoHideDelay: 2000
                    })
                } else {
                    throw new Error('Copy command failed')
                }
            } catch (err) {
                this.$bvToast.toast('Не удалось скопировать данные', {
                    variant: 'danger',
                    title: 'Ошибка копирования',
                    autoHideDelay: 3000
                })
            } finally {
                document.body.removeChild(textArea)
            }
        }
    }
}
</script>

<style scoped>
/* Основные карточки статистики */
.monthly-agent-stats .stat-card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    padding: 1.5rem;
    margin: 0 0.5rem;
}

.monthly-agent-stats .stat-card:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
}

.stat-value {
    font-size: 2rem;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 0.5rem;
}

.stat-label {
    color: #6c757d;
    font-weight: 500;
    font-size: 0.775rem;
    margin-bottom: 0;
    line-height: 0.8rem;
}

/* Цвета для значений */
.text-brand-orange {
    color: #ff6b35 !important;
}

.text-brand-green {
    color: #28a745 !important;
}

.text-brand-red {
    color: #dc3545 !important;
}

.text-brand-warning {
    color: #ffc107 !important;
}

.text-brand-blue {
    color: #007bff !important;
}

/* Карточка таблицы */
.monthly-agent-stats .card {
    border: none;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.monthly-agent-stats .card-body {
    padding: 0rem;
}

/* Стили таблицы */
.monthly-agent-stats .table {
    margin-bottom: 0;
    border-collapse: separate;
    border-spacing: 0;
}

.monthly-agent-stats .table th {
    background-color: #f8f9fa;
    border: none;
    font-weight: 600;
    font-size: 0.875rem;
    padding: 1rem 0.75rem;
    color: #495057;
}

.monthly-agent-stats .table td {
    vertical-align: middle;
    font-size: 0.875rem;
    padding: 0.75rem;
    border: none;
    background: #FBFFFF;
    border-bottom: 1px solid #e9ecef;
}

.monthly-agent-stats .table tbody tr:last-child td {
    border-bottom: none;
}

/* Sticky колонки */
.sticky-column {
    position: sticky;
    left: 0;
    background-color: #f8f9fa;
    z-index: 10;
    border-right: 2px solid #dee2e6;
}

.sticky-right {
    position: sticky;
    right: 0;
    background-color: #e9ecef;
    z-index: 10;
    border-left: 2px solid #dee2e6;
}

.table th.sticky-column {
    background-color: #e9ecef;
    font-weight: 600;
}

/* Hover эффекты */
.table tbody tr:hover {
    background-color: #f8f9fa;
}

.table tbody tr:hover .sticky-column {
    background-color: #e9ecef;
}

.table tbody tr:hover .sticky-right {
    background-color: #f8f9fa;
}

.table tbody tr.table-secondary {
    background-color: #e9ecef;
}

.table tbody tr.table-secondary:hover {
    background-color: #dee2e6;
}

/* Контейнер таблицы */
.table-responsive {
    max-height: 600px;
    overflow-y: auto;
    border-radius: 8px;
    border: 1px solid #e9ecef;
}

.table-responsive::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}

.table-responsive::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

.table-responsive::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Заголовки секций */
.monthly-agent-stats h5 {
    color: #495057;
    font-weight: 600;
    margin-bottom: 1rem;
}

/* Кнопки и селекты */
.monthly-agent-stats .form-control {
    border-radius: 8px;
    border: 1px solid #ced4da;
}

.monthly-agent-stats .form-control:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Равномерное распределение блоков */
.monthly-agent-stats .row.justify-content-between {
    margin: 0 -0.5rem;
}

.monthly-agent-stats .row.justify-content-between .col {
    flex: 1;
    min-width: 0;
    padding: 0 0.5rem;
}

/* Мобильная адаптация */
@media (max-width: 768px) {
    .monthly-agent-stats .row.justify-content-between {
        flex-direction: column;
        margin: 0;
    }
    
    .monthly-agent-stats .row.justify-content-between .col {
        flex: none;
        width: 100%;
        padding: 0;
        margin-bottom: 1rem;
    }
    
    .monthly-agent-stats .stat-card {
        margin: 0;
    }
    
    .monthly-agent-stats h5 {
        font-size: 1.1rem;
        margin-bottom: 0.75rem;
    }
    
    .monthly-agent-stats .stat-value {
        font-size: 1.5rem;
    }
    
    .monthly-agent-stats .stat-label {
        font-size: 0.8rem;
    }
}

@media (max-width: 576px) {
    .monthly-agent-stats .stat-card {
        padding: 1rem;
    }
    
    .monthly-agent-stats .stat-value {
        font-size: 1.25rem;
    }
    
    .monthly-agent-stats .stat-label {
        font-size: 0.75rem;
    }
    
    .monthly-agent-stats h5 {
        font-size: 1rem;
        margin-left: 0 !important;
    }
    
    .monthly-agent-stats .d-flex.justify-content-between {
        flex-direction: column;
        align-items: flex-start !important;
    }
    
    .monthly-agent-stats .d-flex.align-items-center {
        margin-top: 1rem;
        width: 100%;
    }
    
    .monthly-agent-stats .form-control {
        width: 100% !important;
        margin-right: 0 !important;
        margin-bottom: 0.5rem;
    }
    
    /* Адаптация таблицы для мобильных */
    .monthly-agent-stats .table-responsive {
        font-size: 0.75rem;
    }
    
    .monthly-agent-stats .table th,
    .monthly-agent-stats .table td {
        padding: 0.5rem 0.25rem;
        font-size: 0.7rem;
    }
    
    .monthly-agent-stats .sticky-column {
        width: 120px !important;
        min-width: 120px !important;
    }
    
    .monthly-agent-stats .table th.sticky-column {
        font-size: 0.7rem;
    }
}

/* Стили для редактирования в таблице */
.monthly-agent-stats .table .form-control {
    font-size: 0.875rem;
    text-align: center;
    width: 60px;
    margin: 0 auto;
}

.monthly-agent-stats .table .form-control:focus {
    border-color: #0056b3;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.monthly-agent-stats .table .form-control:hover {
    border-color: #0D6247;
}

/* Стили для иконки копирования в заголовке */
.copy-icon {
    margin-left: 5px;
    cursor: pointer;
    color: #6c757d;
    font-size: 12px;
    opacity: 0.7;
    transition: all 0.2s ease;
}

.copy-icon:hover {
    color: #0D6247;
    opacity: 1;
    transform: scale(1.1);
}
</style>
